import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';

import classes from './CoevaluationUserItem.module.css';

const CoevaluationItem = props => {
  const { t } = useTranslation(['lesson']);
  const [activityCoevaluated, setActivityCoevaluated] =
    useState(false);
  useEffect(() => {
    props.activitiesCoevaluated.map(item => {
      if (item === props.homeworkData.idUserHomework) {
        setActivityCoevaluated(true);
      }
    });
  }, [props.activitiesCoevaluated]);

  return (
    <>
      <li className={classes.item}>
        <p className={classes.title}>{props.homeworkData.title}</p>
        <Button
          disabled={
            activityCoevaluated ||
            !(props.coevaluation === 0 && props.evals <= 6)
          }
          onClick={props.coevalUser(
            props.homeworkData.title,
            props.homeworkData.path,
            props.homeworkData.idUserHomework
          )}
          className={classes.coevalBtn}
        >
          {activityCoevaluated ||
          (props.coevaluation === 0 && props.evals <= 6)
            ? t('peer_evaluate')
            : t('peered')}
        </Button>
      </li>
    </>
  );
};

CoevaluationItem.propTypes = {
  // eslint-disable-next-line react/require-default-props
  coevalUser: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  homeworkData: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  evals: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  coevaluation: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  activitiesCoevaluated: PropTypes.array
};

export default CoevaluationItem;
